'use client';
import UKLoadingIcon from '@/components/UKLoadingIcon';
import { useTranslation } from '@/i18n/client';
import { sendPv } from '@/tracks/32896';
import pageSDK from '@/utils/goToPage';
import { useInViewport } from 'ahooks';
import { useEffect, useRef, useState } from 'react';
import Empty from './compoments/Empty';
import ProductCard from './compoments/ProductCard';
import { getProductFeeds, getUserIdentity } from './service';
import style from './style.module.scss';

export default function Module({
  moduleData,
  currencySymbol,
  localInfo,
}: {
  moduleData: any;
  currencySymbol: string;
  localInfo: any;
}) {
  const { t } = useTranslation();
  const curfloorData = moduleData;
  const [productList, setProductList] = useState<any>([]); // 商品列表数据
  const pageNum = useRef(1); // 从第二页开始查，第一页商品和cms主数据接口返回的商品是重复的
  const [pageSize, setPageSize] = useState<number>(10);
  const totalPage = useRef(2);
  const [isPageInit, setIsPageInit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isShowTipPop, setIsShowTipPop] = useState<boolean>(false); // 新人弹框是否展示
  const sentinelRef = useRef<HTMLElement>(null);

  const [isVisible, ratio] = useInViewport(sentinelRef.current);

  useEffect(() => {
    if (isVisible) {
      pageNum.current++;
      if (pageNum.current <= totalPage.current) {
        queryPage();
      }
    }
  }, [isVisible]);

  useEffect(() => {
    checkIsNewUser();
    initConfig();
    sendPv.Activity_Discount();
  }, []);

  // 获取更多新人促销商品
  const queryPage = () => {
    setLoading(true);
    const { externalParams } = curfloorData;
    const activityInfo = JSON.parse(externalParams);
    const activityId = activityInfo?.inputsValue?.activityId;
    const productListLen = productList?.length;
    const scrollId = productListLen ? productList[productListLen - 1]?.extInfo?.scrollId : null;
    getProductFeeds({
      cuPage: pageNum.current,
      pageSize: pageSize,
      params: { activityId: activityId, scrollId: scrollId },
    })
      .then((res: any) => {
        setLoading(false);
        if (res.data && res.data.length) {
          const totalNum = res.total;
          const allProductList = productList.concat(res.data);
          const totalPageData =
            totalNum % pageSize === 0 ? totalNum / pageSize : Math.floor(totalNum / pageSize) + 1;
          setProductList(allProductList);
          totalPage.current = totalPageData;
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // 查询用户身份是否为新人
  const checkIsNewUser = () => {
    getUserIdentity()
      .then((res: any) => {
        if (res) {
          // 是否新人(IDENTITY_NEWCOMER) 0-不是  1-是
          // if (Number(res.IDENTITY_NEWCOMER) === 0) {
          //   service.toast("Sorry, for new users only");
          // }
          setIsShowTipPop(Number(res.IDENTITY_NEWCOMER) === 0);
        } else {
          setIsShowTipPop(false);
        }
      })
      .catch(() => {
        setIsShowTipPop(false);
      });
    // }
  };

  /** 初始化配置 */
  const initConfig = () => {
    const { externalData } = curfloorData;

    // 批次设置
    try {
      setIsPageInit(true);
      if (externalData) {
        const productList = externalData.data?.products?.list;
        if (productList?.length) {
          productList
            .filter((sku: any) => sku?.skuId)
            .map((item: any) => {
              const k = item;
              return {
                ...item,
                imageUrl: k?.imageUrl || k?.skuImageUrl || '',
                skuName: k?.skuName || '',
                realPrice: k?.realPrice || String(k?.skuPrice) || '',
                originalPrice: k?.originalPrice || '',
                jumpUrl: k?.jumpUrl || null,
              };
              // this.productList.push(skuInfo);
            });
          setProductList(productList);
        }
      } else {
        // 无批次数据兜底
        // setProductList([]);
      }
    } catch (e) {
      setIsPageInit(true);
      console.log('h5-module-product-catch', e);
    }
  };

  const getEventTrackingInfo = (product: any, index: number) => {
    const eventTrackingInfo = {
      skuid: isNaN(product?.skuId) ? '-100' : product.skuId.toString(),
      firprice: isNaN(product?.realPrice) ? -100 : Number(product?.realPrice),
      firpricetype: '11',
      secprice: isNaN(product?.originalPrice) ? -100 : Number(product?.originalPrice),
      secpricetype: '83',
      index: index,
      isStock: product?.stock ? '1' : '0',
    };
    return eventTrackingInfo;
  };

  /**
   * 跳转到首页
   */
  const jumpToHome = () => {
    pageSDK.goToPage({
      jumpType: 'fun',
      jumpValue: {
        obj: {
          urlJumpTerminalList: [
            {
              terminal: 5,
              jumpCode: 'home',
            },
          ],
        },
      },
    });
  };

  return (
    <div className={style.uk_h5_product_activity}>
      {/* cms主数据接口请求完毕才展示 */}
      {isPageInit && (
        <div className={style.product_list}>
          {productList?.length ? (
            productList.map((item: any, index: number) => {
              return (
                <ProductCard
                  localInfo={localInfo}
                  key={index}
                  currencySymbol={currencySymbol}
                  skuInfo={item}
                  eventTrackingInfo={getEventTrackingInfo(item, index) || ''}
                />
              );
            })
          ) : (
            <Empty />
          )}
        </div>
      )}
      {/* @ts-ignore */}
      <div ref={sentinelRef} style={{ height: '1px' }}></div>

      {loading && (
        <div className={style.loading}>
          <UKLoadingIcon />
          {t('cms.ukH5ProductActivity.loadingText')}
        </div>
      )}

      {/* 非新人用户弹框提示 */}
      {isShowTipPop && (
        <div className={style.tips_wrap}>
          <div className={style.tips_content}>
            <div className={style.main_title}>{t('cms.ukH5ProductActivity.goHomeTip')}</div>
            <div className={style.operate_btn} onClick={jumpToHome}>
              {t('cms.ukH5ProductActivity.goHomeBtnTip')}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
